import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import anonymousProfile from "../../../../../assets/images/sample.png";

// import MDAvatar from "components/MDAvatar";

function ComplexProjectCard({ user }) {
  return (
    <Card>
      <MDBox p={3}>
        <MDBox display="flex" alignItems="flex-start" ml={-1}>
          <MDBox
            sx={{
              width: "90px",
              height: "90px",
              borderRadius: "10px",
              overflow: "hidden",
              mt: -6,
            }}
          >
            <img
              src={user?.profilePicture || anonymousProfile}
              alt={user?.name || ""}
              height="100%"
              width="100%"
              style={{ borderRadius: "50%" }}
            />
          </MDBox>
          <MDBox ml={2} mt={-1} lineHeight={0}>
            <MDTypography variant="h5" textTransform="capitalize" fontWeight="medium">
              {user?.name}
            </MDTypography>
            <MDTypography variant="body2" textTransform="capitalize" sx={{ fontSize: "14px" }}>
              {user?.role}
            </MDTypography>
            <MDTypography variant="body2" textTransform="capitalize" sx={{ fontSize: "14px" }}>
              {user?.location}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ComplexProjectCard;
